import { Component, OnInit } from '@angular/core';
import { Resources } from 'src/app/models';
import { AdminService } from 'src/app/services/admin.service';
import * as jquery from 'jquery';

@Component({
  selector: 'app-listing',
  templateUrl: './listing.component.html',
  styleUrls: ['./listing.component.scss']
})
export class ListingComponent implements OnInit {

  modalText = 'Loading...';
  resources: Resources[] = [];

  constructor(
    private adminService: AdminService
  ) { }

  ngOnInit(): void {
    this.getResources();
  }

  private getResources(): void {

    this.showProgressModal();

    this.adminService.getResources('science')
      .subscribe(response => {
        this.resources = response.data.resources;
        this.hideProgressModal();
      });
  }

  private showProgressModal() {
    jquery('#loaderSpin').show();
  }

  private hideProgressModal() {
    jquery('#loaderSpin').hide();
  }

}
